const exportedObject = {
  // baseUrl: 'https://xwrf74qgo1.execute-api.us-east-1.amazonaws.com/dev'
  baseUrl: 'https://p04rn0yxqa.execute-api.us-east-1.amazonaws.com/prod'
};

export default exportedObject;